import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import * as DB_INTERFACE from '../../../../components/tickets/tickets-form/interfaces/DB.interface';
import { UserHistory } from '@/modules/users/domain/user-history';
import { Typing } from '@/modules/tickets/shared/domain/typing';

class TicketsRepository extends HttpRepository {
    private static readonly RESOURCE = 'tickets';

    /**
     * Obtiene los datos necesarios para la creación de tickets, tanto de acceso como de requerimiento
     * @param id id del cliente que está en línea
     * @param type
     */
    getDataCreateTicket(id: number, type: string) {
        return this.get(
            this.createUri([
                'views',
                'customers',
                id,
                `${TicketsRepository.RESOURCE}`,
                type,
                'generate',
            ]),
            this.createAuthorizationHeader(),
        );
    }

    async getTypings(id: number, type: string): Promise<Typing[]> {
        return (
            await this.get(
                this.createUri([
                    'views',
                    'customers',
                    id,
                    `${TicketsRepository.RESOURCE}`,
                    type,
                    'generate',
                ]),
                this.createAuthorizationHeader(),
            )
        ).data.values.typings;
    }

    /**
     * Permite la creación de tickets, tanto de acceso como de requerimiento
     */
    createTicket(ticket: any) {
        return this.post(
            this.createUri([`${TicketsRepository.RESOURCE}`]),
            ticket,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Devuelve el ticket de acceso dado su ID
     */
    getAccessTicket(ticketId: number) {
        return this.get(
            this.createUri([`${TicketsRepository.RESOURCE}`, ticketId]),
            this.createAuthorizationHeader(),
        );
    }

    /**
  * Permite la creación modificación de Tickets
    http://localhost:8000/api/v1/access-permissions?ticketId=303756
  */
    updateTicket(ticket: DB_INTERFACE.accessTicketModificationInterface) {
        return this.patch(
            this.createUri([`${TicketsRepository.RESOURCE}`]),
            ticket,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Obtiene el ticket dado el id para visualizar los detalles del ticket o del Permiso de Trabajo generado por ese ticket
     * (en caso de que sea un ticket de acceso)
     * @param id id del ticket
     */
    getTicketById(id: number) {
        return this.get(
            this.createUri([`${TicketsRepository.RESOURCE}`, id]),
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Obtiene el ticket dado el id para visualizar los detalles del ticket o del Permiso de Trabajo generado por ese ticket
     * (en caso de que sea un ticket de acceso)
     * @param id id del ticket
     */
    getTicketWorkflowDetailById(
        id: number,
        accessPermissionId: number,
        roleId: number,
        customerType: number,
        accessMotives: number[],
    ) {
        return this.get(
            this.createUri([`${TicketsRepository.RESOURCE}`, id, 'workflow-detail'], {
                accessPermissionId,
                roleId,
                customerType,
                accessMotives,
            }),
            this.createAuthorizationHeader(),
        );
    }

    async getTicketContactHistory(contactId: number): Promise<UserHistory> {
        return (
            await this.get(
                `${TicketsRepository.RESOURCE}/year-detail?contactId=${contactId}`,
                this.createAuthorizationHeader(),
            )
        ).data.results;
    }
}

export default new TicketsRepository();
